import React, { useEffect, useState } from "react";
import { isIOS, getDeviceType, getBrowserName } from "lib/deviceInfo";
import CommonSnackbarView from "presentational/common/CommonSnackbarView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";
import config from "lib/fr-config";

const zIndexOfSnackbar = config.css.zIndex.snackbar.PWAInstallForAndroid;

PWAInstallPromptForAndroid.propTypes = {
  readyToShow: PropTypes.bool.isRequired
};

function PWAInstallPromptForAndroid(props) {
  const { readyToShow, hasLoggedIn } = props;
  const [promptEventForChrome, setPromptEventForChrome] = useState(null);
  const [isAndroidMobileBrowser, setIsAndroidMobileBrowser] = useState(false);
  const [allowedToInstallForChrome, setAllowedToInstallForChrome] =
    useState(false);
  const [hideSnackbar, setHideSnackbar] = useState(false);

  useEffect(() => {
    initEvent();
  }, []);
  useEffect(() => {
    if (!hasLoggedIn) return undefined;

    checkMobileBrowser();
  }, [hasLoggedIn]);

  const checkMobileBrowser = () => {
    if (isIOS || getDeviceType() === "desktop") {
      return null;
    }

    setIsAndroidMobileBrowser(true);
  };

  const initEvent = () => {
    window.addEventListener("beforeinstallprompt", event => {
      /**
       * 이벤트는 웹엡 시작시 등록(add)되어야 하며,
       * pwa의 조건이 성립하면(pwa 미설치상황, 인앱브라우저 아닌 일반브라우저상황 등등) 이 함수가 실행된다.
       */
      event.preventDefault();
      setPromptEventForChrome(event);
    });
  };

  /** standalone 점검 함수 */
  // const isAlreadyStandalone = () => {
  //   const isStandalone = window.matchMedia(
  //     "(display-mode: standalone)"
  //   ).matches;
  //   if (navigator.standalone || isStandalone) {
  //     return true;
  //     // } else if (document.referrer.startsWith("android-app://")) {
  //     //   console.log("twa");
  //     //   return true;
  //   } else {
  //     return false;
  //   }
  // };

  const addToHomeScreenForChrome = () => {
    promptEventForChrome.prompt();
    promptEventForChrome.userChoice.then(choiceResult => {
      if (choiceResult.outcome === "accepted") {
        // console.log("User accepted the A2HS prompt");
        setAllowedToInstallForChrome(true);
      } else {
        // <choiceResult.outcome === "dismissed" 인 경우>
        // console.log("User dismissed the A2HS prompt");
      }
    });

    setHideSnackbar(true);
  };

  const getSnackbarType = () => {
    const browserName = getBrowserName();
    if (browserName !== "Chrome") {
      return "otherBrowser";
    } else if (!!promptEventForChrome) {
      return "notInstalled";
    }

    return "installed";
  };

  const getSnackbarContent = () => {
    const snackbarType = getSnackbarType();

    switch (snackbarType) {
      case "notInstalled":
        return <TXT name="msg_PWARecommendation" />;
      case "otherBrowser":
        return <TXT name="msg_recommendChromeBrowser" />;
      case "installed":
        return <span></span>;

      default:
        console.error(`wrong snackbarType:${snackbarType}`);
        break;
    }
  };

  const getSnackbarBtnArray = () => {
    const snackbarType = getSnackbarType();

    switch (snackbarType) {
      case "notInstalled":
        return [
          {
            color: "primary",
            func: addToHomeScreenForChrome,
            btnText: <TXT name="btnSnackbar_PWAInstall" />
          },
          {
            color: "secondary",
            func: handleClose,
            btnText: <TXT name="btnSnackbar_PWAInstallLater" />
          }
        ];
      case "otherBrowser":
        return [
          {
            color: "primary",
            func: handleClose,
            btnText: <TXT name="btnSnackbar_gotIt" />
          }
        ];
      case "installed":
        return [];

      default:
        console.error(`wrong snackbarType:${snackbarType}`);
        break;
    }
  };

  const needOpen = () => {
    const open =
      getSnackbarType() !== "installed" &&
      isAndroidMobileBrowser &&
      !allowedToInstallForChrome &&
      !hideSnackbar &&
      readyToShow;
    return open;
  };

  const handleClose = () => {
    setHideSnackbar(true);
  };

  return (
    <CommonSnackbarView
      open={needOpen()}
      contentComponent={getSnackbarContent()}
      buttonInfoArray={getSnackbarBtnArray()}
      zIndexOfSnackbar={zIndexOfSnackbar}
    />
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(PWAInstallPromptForAndroid);
